"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var _SegmentedButton_1 = __importDefault(require("./_SegmentedButton"));
var segmentedButtons_module_scss_1 = __importDefault(require("./segmentedButtons.module.scss"));
/**
 * ### Production-ready Checklist:
 * * (✔) implementation of component approved by design team;
 * * (✔) has storybook, covered with stories and documentation;
 * * (✔) has tests: test every prop, every state and every interaction that's js related;
 * * (see apps/test/unit/componentLibrary/SegmentedButtonsTest.jsx)
 * * (?) passes accessibility checks;
 *
 * ###  Status: ```Ready for dev```
 * Design System: Segmented Buttons Component.
 * Can be used to render Segmented Buttons. (Group of Buttons)
 */
var SegmentedButtons = function (_a) {
    var buttons = _a.buttons, selectedButtonValue = _a.selectedButtonValue, onChange = _a.onChange, className = _a.className, _b = _a.size, size = _b === void 0 ? 'm' : _b, _c = _a.type, type = _c === void 0 ? 'withLabel' : _c;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(segmentedButtons_module_scss_1.default.segmentedButtons, segmentedButtons_module_scss_1.default["segmentedButtons-".concat(size)], className) }, buttons.map(function (_a) {
        var label = _a.label, disabled = _a.disabled, iconLeft = _a.iconLeft, iconRight = _a.iconRight, icon = _a.icon, value = _a.value;
        return (react_1.default.createElement(_SegmentedButton_1.default, { key: label, selected: selectedButtonValue === value, label: label, onChange: onChange, disabled: disabled, iconLeft: iconLeft, iconRight: iconRight, icon: icon, buttonType: type, value: value }));
    })));
};
exports.default = SegmentedButtons;
